// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__zNIRn","row":"Node_row__un_yP","label":"Node_label__p168e","footer":"Node_footer__2Gk2N"};